import React from 'react';
import { Link } from 'react-router-dom';
import './aboutus.css';



function AboutUs() {
  return (
    <div className="about-us-container">
      <section className="about-header">
        <h1>About Eye Care Digital Library</h1>
        <p>Your Learning Hub for Eye Care and Vision Science</p>
      </section>

      <section className="about-content">
        <div className="about-info">
          <h2>Our Mission</h2>
          <p>
            The Eye Care Digital Library is dedicated to providing high-quality resources and materials for students, professionals, and enthusiasts in the field of eye care and vision science. Our mission is to create a comprehensive, easily accessible, and interactive learning platform that empowers individuals to enhance their knowledge and understanding of eye health.
          </p>
        </div>
        
        <div className="about-info">
          <h2>What We Offer</h2>
          <ul>
            <li>Comprehensive Learning Materials</li>
            <li>Interactive Visuals and Tools</li>
            <li>Expertly Curated Articles and Research</li>
            <li>Interactive Quizzes and Self-Assessments</li>
            <li>Courses for Students and Professionals</li>
          </ul>
        </div>
      </section>


      <section id="about" className="about-section">
            <div className="about-content">
                <div className="text-section">
                <h2>About Us</h2>
                <p>
                    Welcome to the Eye Care Digital Library, an innovative platform designed to support students, professionals, and researchers in the dynamic fields of optometry and vision science. Our mission is to provide a comprehensive digital resource hub that fosters learning, knowledge-sharing, and research development in the eye care community.
                </p>
                <p>
                    We offer an extensive collection of research papers, articles, textbooks, and clinical resources, all curated by leading experts in the field. Our platform is designed to empower individuals at all levels, from students exploring optometry to seasoned professionals looking for advanced studies in vision science.
                </p>
                <p>
                    At the Eye Care Digital Library, we are committed to promoting excellence in eye care education and advancing vision science through continuous innovation. Our goal is to create an accessible, up-to-date, and user-friendly platform that caters to the evolving needs of the global eye care community.
                </p>
                <p>
                    With a focus on collaboration and inclusivity, we strive to be a trusted resource for cutting-edge research and knowledge, helping to shape the future of eye care and improve vision health worldwide.
                </p>
                </div>
                <div className="image-section">
                <img src="/logo.jpg" alt="Eye Care" />
                </div>
            </div>
         </section>


      <section className="about-footer">
        <h1>Join Us Today!</h1>
        <p>Become a part of our community and begin your journey in the world of eye care and vision science.</p>
        <Link to="/signup"><button className="cta-button">Explore Now</button></Link>
      </section>
    </div>
  );
}

export default AboutUs;
